module.exports = __webpack_public_path__ + "media/src/images/styleguide/IMG_1809-f395cc77548710115f24b76fb4ab0479.png";